import { GenericValue } from 'hisng';
import { Directive } from '@angular/core';
import { AbstractFieldComponent } from '../abstract-field.component';

@Directive()
export abstract class WithDatasourceComponent<T extends GenericValue> extends AbstractFieldComponent<T> {
    readonly datasourceName: string;
    readonly fieldDisplayName: string;

    constructor(
        parameters: {
            readonly datasourceName: string;
            readonly fieldDisplayName: string;
            readonly i18nIdentifier: string;
        } ) {
        super( parameters.i18nIdentifier );
        this.datasourceName = parameters.datasourceName;
        this.fieldDisplayName = parameters.fieldDisplayName;
    }

    abstract getFieldValue( t?: T ): string | undefined;
}
